module.exports = __webpack_public_path__ + "img/jump-screenshot.61b5e6ba.png";